// File validation constants
export const VALID_FILE_EXTENSIONS = [
  '.doc',
  '.docx',
  '.pdf',
  '.png',
  '.jpg',
  '.jpeg',
  '.xlsx',
  '.xls',
]

export const MAX_FILE_SIZE = 50 * 1024 * 1024 // 50 MB in bytes

export const SUPPORTED_FORMATS_TEXT = 'DOC, PDF, PNG, JPG, XLSX'
export const MAX_FILE_SIZE_TEXT = '50 MB'
